import React from 'react'
import Form from './form'

function Index({state,moduleData,metadataMap,isCheckoutScreen, showTvProviderBtn, continueWithoutSubscription, continueWithoutSubscriptionLabel,checkoutModuleData,isFreeLogin}) {
  return (
    <div>
        <Form state={state} moduleData={moduleData} metadataMap={moduleData?.metadataMap} isCheckoutScreen={isCheckoutScreen} showTvProviderBtn={showTvProviderBtn} continueWithoutSubscription={continueWithoutSubscription} continueWithoutSubscriptionLabel={continueWithoutSubscriptionLabel} checkoutModuleData={checkoutModuleData} isFreeLogin={isFreeLogin} />
    </div>
  )
}

export default Index